import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeftAlign = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.252,
		d: "M2.666 4.333h10.667m-10.667 4h6.667m-6.667 4h9.333"
	})
});
export default SvgLeftAlign;
